import { render, staticRenderFns } from "./MyProfileTab.vue?vue&type=template&id=1bdd92b9&"
import script from "./MyProfileTab.vue?vue&type=script&lang=js&"
export * from "./MyProfileTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports